/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { connect, useSelector, useDispatch } from "react-redux";
import * as actions from "./actions";
import { fetchCurrentLocationRequest } from "../Location/actions";
import { getAppointmentReasons } from "./reducers";
import RenderReasonList from "./RenderReasonList";
import * as bookingActions from "../Booking/actions";
import { getAvailabilityRequests } from "../Booking/reducers";
import { isEmpty } from "lodash";

const Reasons = ({
	fetchCatalogueItemsRequest,
	match,
	practiceId,
	practitionerId,
	reasons,
	toggleItem,
	selectItem,
	unselectItem,
	themeColor,
	availabilityRequests,
}) => {
	const [filteredReasons, setFilteredReasons] = React.useState(reasons);
	const dispatch = useDispatch();

	const currentLocation = useSelector(
		(state) => state.locations.currentLocation,
	);

	useEffect(() => {
		if (practiceId) {
			fetchCatalogueItemsRequest(practiceId);
		}
	}, [fetchCatalogueItemsRequest, practiceId]);

	useEffect(() => {
		if (isEmpty(currentLocation)) {
			dispatch(fetchCurrentLocationRequest(practiceId));
		}
	}, [currentLocation, practiceId, dispatch]);

	useEffect(() => {
		if (practitionerId) {
			const filteredReasons = reasons.filter((reason) =>
				reason.displayPractitioners
					? reason.displayPractitioners.map((practitioner) => practitioner.id.toString()).includes(practitionerId)
					: true,
			);
			setFilteredReasons(filteredReasons);
		} else {
			setFilteredReasons(reasons);
		}
	}, [reasons, practitionerId]);

	return (
		filteredReasons && (
			<RenderReasonList
				reasons={filteredReasons}
				selectItem={selectItem}
				themeColor={themeColor}
				unselectItem={unselectItem}
				toggleItem={toggleItem}
				availabilityRequests={availabilityRequests}
				practitionerId={practitionerId}
				multiSelect={false}
			/>
		)
	);
};

const mapStateToProps = (state) => ({
	reasons: getAppointmentReasons(state.appointmentReasons),
	availabilityRequests: getAvailabilityRequests(state.booking),
});

export default connect(mapStateToProps, { ...actions, ...bookingActions })(
	Reasons,
);
